import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/common';

export const Header: React.FC = () => {
  const { user, signOut, isLoading } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <h1 className="text-xl font-bold text-primary-500">
                AMV Gomecano
              </h1>
            </div>
          </div>

          {/* Navigation supprimée - utilisation de la sidebar uniquement */}

          {/* User menu */}
          <div className="flex items-center space-x-4">
            {user && (
              <span className="text-sm text-gray-700">
                {user.email}
              </span>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={signOut}
              isLoading={isLoading}
            >
              Déconnexion
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
